module.exports = __webpack_public_path__ + "static/media/product-detail-placeholder.4bd6ec27.webp";